import apiClient from './apiClient';

export const contactService = {
  submitContact: async (data: {
    name: string;
    email: string;
    phone?: string;
    subject: string;
    message: string;
  }) => {
    const response = await apiClient.post('/contact', data);
    return response.data;
  },

  getAllContacts: async (page = 1, limit = 10) => {
    const response = await apiClient.get('/contact', {
      params: { page, limit },
    });
    return response.data;
  },

  updateContactStatus: async (id: string, status: string) => {
    const response = await apiClient.put(`/contact/${id}/status`, { status });
    return response.data;
  },

  deleteContact: async (id: string) => {
    const response = await apiClient.delete(`/contact/${id}`);
    return response.data;
  },
};
